import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const UNLINKED_MNCMS_QUERY_KEY = "mncmsUnlinkedMessages";

/**
 * The MN-CMS needs-attention queue (KIN-1892): inbound messages the hospital sent
 * that aren't fully attached to a chart — either we couldn't patient-match them at
 * all, or they matched a patient but no pregnancy. The second case is the one that
 * keeps failing quietly: until a received message is attached to the pregnancy, the
 * outbound send gate refuses every send for it.
 *
 * Rows are oldest-first and carry `hl7MessageContent` + `xslContent`, so the message
 * can be read here without a second request — which matters, because reading it is
 * how the user works out who it belongs to.
 */
export const useUnlinkedMncmsMessages = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: [UNLINKED_MNCMS_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/mncms/inbound-messages/unlinked`
      );

      return response.data?.data ?? response.data;
    },
    enabled: !!tenantVal,
  });
};
